import { z } from 'zod';
export const priceRebuildRequest = z.object({ fingerprint: z.string().regex(/^[a-f0-9]{32}$/) }).strict();
export interface PriceRebuildPreview {
  fingerprint: string; rebuild: number; exclude: number; review: number;
  samples: Array<{ symbol: string; date: string; action: string; before: string; after: string | null; sourceDate: string | null }>;
}
export interface PriceRebuildResult { rebuilt: number; excluded: number; review: number }
export interface PriceRebuildStatus {
  run: null | { id: string; status: string; error: string | null; output: PriceRebuildResult | null };
}
